import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import GameTopBar from 'components/GameTopBar';
import Game from 'components/Game';
import Layout from 'components/Layout';
import { usePrevious, useGame } from 'common/state';
import { useGameDataHistory } from 'common/hooks';
import { verifyAndFixGameData } from 'common/logic';

function PreviousGameScreen() {
  const { language, date } = useParams();
  const [previousState, previousActions] = usePrevious();
  const [gameState, gameActions] = useGame();
  const { getGameData, updateGameData } = useGameDataHistory();

  useEffect(() => {
    previousActions.load(date, language);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      previousState.gameId !== gameState.id ||
      previousState.language !== gameState.language
    ) {
      const gameData = verifyAndFixGameData(
        previousState.gameSpec,
        getGameData(previousState.gameId, previousState.language),
      );
      gameActions.prepare(
        previousState.language,
        previousState.gameId,
        previousState.date,
        previousState.gameSpec,
        gameData,
      );
    }
  }, [previousState, gameState, gameActions, getGameData]);

  useEffect(() => {
    updateGameData(gameState);
  }, [gameState, updateGameData]);

  return (
    <Layout>
      <GameTopBar />
      {previousState.status === 'loaded' &&
        gameState.status !== 'unprepared' &&
        !!gameState.spec && <Game />}
    </Layout>
  );
}

export default PreviousGameScreen;
